import {sendEmail, sendSMS} from '@api/ticket'
import {sendQuoteReferrer} from '@/api/order'
export default {
  computed:{
    initReferContent(){
      let {send_to_referrer} = this.formData||{}
      let {sme_quote_url_data,referrer_endorsement_need_pay_url_data,referrer_renew_reply_url_data,refer_case_quote_url_data,new_quote_url_data} = send_to_referrer||{}
      if(this.isSME)
        return sme_quote_url_data
      if(this.isEndorse)
        return referrer_endorsement_need_pay_url_data
      if(this.isRenew)
        return referrer_renew_reply_url_data
      if(this.isReferCase){
        return refer_case_quote_url_data
      }
      return new_quote_url_data
    },
    initReferRejectContent(){
      let {send_to_referrer} = this.sendForm||{}
      let {refer_case_reject_url_data,referrer_renew_reject_url_data} = send_to_referrer||{}
      if(this.isRenew)
        return referrer_renew_reject_url_data
      return refer_case_reject_url_data
    }
  },
  methods:{
    getIsReject(params){
      let {cases=[]} = params||{}
      let is_quote_arr = cases.filter(item=>item.quote_status==1)||[]
      return is_quote_arr.length>0?false:true
    },
    mixinNetwork(){
      return{
        sendSMS: async (params) => {
          const {data} = await sendSMS({
            ...params
          })
        },
        sendEmail: async (params) => {
          const {data} = await sendEmail({
            ...params
          })
        },
        sendQuoteReferrer: async (params) => {
          const {data} = await sendQuoteReferrer({
            ...params
          })
        },
      }
    }
  }
}
